import {
  BsFacebook,
  BsInstagram,
  BsLinkedin,
  BsMedium,
  BsTwitterX,
} from "react-icons/bs";
import "./footer.css";
import { useNavigate } from "react-router-dom";
import { useNavigateAndScroll } from "../../../hooks/useNavigateAndScroll";
import BrocolyLink from "../../../utils/BrocolyLink";

export const Footer = () => {
  const navigate = useNavigate();

  const navigateAndScroll = useNavigateAndScroll();

  const handleNavigate = (route) => {
    navigate(route);
  };

  const scrollToTop = () => {
    const element = document.getElementById("header");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="footer-wrapper">
      <div className="footer-primary">
        <div className="footer-column">
          <img
            className="logo-binamics pointer"
            style={{ marginBottom: 24, height: "2rem" }}
            src={`${process.env.PUBLIC_URL}/assets/imagenes/footer/logo-binamics-blanco.png`}
            alt="logo-empresa"
            onClick={() => handleNavigate("/")}
          />
          <p className="footer-column-title">Oficina</p>
          <p className="footer-text">Villa María, Córdoba</p>
          <p className="footer-text">
            Gral Paz 564 - Edificio Boro. Piso 5 - Oficina 13
          </p>

          <p className="footer-text">
            <a href="tel: +5493534012614">Teléfono: +54 9 3534 01 2614</a>
          </p>
        </div>
      </div>
      <div className="footer-secondary">
        <div className="footer-column">
          <p className="footer-column-title">Descubre el alcance de binamics</p>
          <p
            className="footer-text pointer"
            onClick={() => navigateAndScroll("/business-intelligence", "top")}
          >
            Inteligencia de negocios
          </p>
          <p
            className="footer-text pointer"
            style={{ marginLeft: 8 }}
            onClick={() => navigateAndScroll("/business-intelligence", "data")}
          >
            Análisis de datos
          </p>
          <p
            className="footer-text pointer"
            style={{ marginLeft: 8 }}
            onClick={() =>
              navigateAndScroll("/business-intelligence", "business")
            }
          >
            Análisis empresarial
          </p>
          <p
            className="footer-text pointer"
            onClick={() => navigateAndScroll("/", "brocoly")}
          >
            Inteligencia del cliente
          </p>
          <BrocolyLink>
            <p className="footer-text" style={{ marginLeft: 8 }}>
              CRM
            </p>
          </BrocolyLink>
          <BrocolyLink>
            <p className="footer-text" style={{ marginLeft: 8 }}>
              Whatsapp + Chatbot
            </p>
          </BrocolyLink>
        </div>
        <div className="footer-column">
          <p className="footer-column-title">Quiénes somos</p>
          <p
            className="footer-text"
            onClick={() => navigateAndScroll("/about")}
          >
            Acerca de
          </p>
          <p className="footer-text" onClick={() => navigateAndScroll("/demo", "top")}>
            Contacto
          </p>
          <p
            className="footer-text"
            onClick={() => navigateAndScroll("/about", "join-us")}
          >
            Trabaja con nosotros
          </p>
          {/* <p className="footer-text">Testimonios</p>
          <p className="footer-text">Blog</p> */}
        </div>
        <div className="footer-column">
          <p className="footer-column-title">Seguinos en</p>
          <a
            className="footer-text"
            href="https://www.linkedin.com/company/binamics"
            target="_blank"
            rel="noreferrer"
          >
            <span className="horizontal gap-8 pointer">
              <BsLinkedin fill="white" />
              Linkedin
            </span>
          </a>
          <a
            className="footer-text"
            href="https://www.instagram.com/binamics_ar"
            target="_blank"
            rel="noreferrer"
          >
            <span className="horizontal gap-8 pointer">
              <BsInstagram />
              Instagram
            </span>
          </a>
          <a
            className="footer-text"
            href="https://medium.com/binamics-stories"
            target="_blank"
            rel="noreferrer"
          >
            <span className="horizontal gap-8 pointer">
              <BsMedium fill="white" />
              Medium
            </span>
          </a>
          <a
            className="footer-text"
            href="https://twitter.com/binamics_ar"
            target="_blank"
            rel="noreferrer"
          >
            <span className="horizontal gap-8 pointer">
              <BsTwitterX fill="white" />X
            </span>
          </a>
          <a
            className="footer-text"
            href="https://www.facebook.com/p/Binamics-SRL-100075585956835"
            target="_blank"
            rel="noreferrer"
          >
            <span className="horizontal gap-8 pointer">
              <BsFacebook fill="white" />
              Facebook
            </span>
          </a>
        </div>
      </div>
      <img
        src={`${process.env.PUBLIC_URL}/assets/imagenes/home/icoflechatop.png`}
        className="image-go-top pointer"
        alt="boton-top"
        onClick={scrollToTop}
      />
    </footer>
  );
};
